const isLoading = ref(false)

const startLoading = () => {
  isLoading.value = true
}

const stopLoading = () => {
  isLoading.value = false
}

export const usePageBlockingLoading = () => {
  return {
    startLoading,
    stopLoading,
    isLoading: readonly(isLoading),
  }
}
